module.exports = __webpack_public_path__ + "static/media/diagnoses.5b50074d.svg";